<template id="principal">
    <div>
        <v-container class="grey lighten-5">
            <v-row dense>
                <!-- <v-col cols="12" md="3" sm="6">
                    <v-text-field label="Tipo de Equipo" dense v-model="codigoqr">
                    </v-text-field>
                </v-col> -->
                <v-col cols="12" sm="6" md="6">
                    <v-select item-color="green" color="green darken-2" dense v-model="codigo" :items="listadocodigo"
                        label="Tipo de Equipo" item-text="nombre" item-value="valor"></v-select>
                </v-col>

                <v-col cols="12" md="2" sm="4">
                    <v-text-field label="Desde:" dense v-model="desde">
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="4">
                    <v-text-field label="Hasta:" dense v-model="hasta">
                    </v-text-field>
                </v-col>
                <!-- <v-col cols="12" md="2" sd="2">
            <v-text-field label="Tamaño" dense v-model="dimension">
            </v-text-field>
          </v-col> -->
                <v-col cols="12" md="2" sd="2">
                    <v-btn color="red lighten-2" dark @click="cargarEquipo">
                        Generar QR
                    </v-btn>
                </v-col>
            </v-row>

            <div id="printtopaper">
                <v-row dense align="center">
                    <v-col align-self="center" cols="12" md="4" sd="4" v-for="cod in codigos" :key="cod.id">
                        <v-row align="center" justify="center">
                            <h6>
                                N° de Equipo: {{ cod.codgral }}
                            </h6>
                        </v-row>
                        <v-row align="center" justify="center">
                            <h6>
                                Descripción: {{ cod.detalle }}
                            </h6>
                        </v-row>
                        <v-row align="center" justify="center">
                            <h6>
                                Marca: {{ cod.marca }}
                            </h6>
                        </v-row>
                        <v-row align="center" justify="center">
                            <h6>
                                Modelo: {{ cod.modelo }}
                            </h6>

                        </v-row>
                        <v-row align="center" justify="center">
                            <vue-qr :text="cod.observ" :size="dimension"></vue-qr>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>
<script>
import VueQr from "vue-qr";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        codigoqr: "",
        dimension: 100,
        valid: false,
        tipo: "",
        desde: 0,
        hasta: 0,
        cantidad: 0,
        codigos: [],
        codigo: "",
        detalle: "",
        marca: "",
        modelo: "",
        id: "",
        listadocodigo: [
            { nombre: "Vehículo", valor: "V" },
            { nombre: "Equipo / Herramienta", valor: "H" },
            { nombre: "Instrumento Medición Eléctrica / Electrónica", valor: "E" },
            { nombre: "Instrumento Medición Mecánica", valor: "M" },
            { nombre: "Instrumento Civil", valor: "C" },
            { nombre: "Elemento de Seguridad", valor: "S" },
        ],
    }),
    components: { VueQr },
    methods: {
        cargarEquipo(codigogral) {
            var codgral = codigogral;
            let self = this;
            axios
                .get("/SSGG/CargarEquipoEtiqueta?", {
                    params: {
                        codgral: self.codigo,
                        desde: self.desde,
                        hasta: self.hasta,
                    },
                })
                .then((response) => {
                    self.codigos = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },


        generarQR() {
            this.codigos = [];
            const codigo = this.codigo;
            const desde = this.desde;
            const hasta = this.hasta;
            const fill = (number, len) =>
                "0".repeat(len - number.toString().length) + number.toString();
            console.log("desde " + desde + " hasta " + hasta)
            // if (desde != "0" && hasta != "0") {
            //     this.codigos.push(this.codigoqr);
            // } else {
            for (let i = desde; i <= hasta; i++) {

                var codigogral = codigo + i
                this.cargarEquipo(codigogral);
            }
        },
    },
};
</script>
  
<style>
.conteiner {
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
</style>
  